module.exports = __webpack_public_path__ + "static/media/slidee-5.05390f35.jpg";